<template>
  <div
    class="v-select"
    :class="{
      [extraClass]: true,
      ['has-error']: errors.length,
      ['singular']: isOptionSingular
    }"
  >
    <div v-if="label" class="v-select__label-wrapper">
      {{ label }} <span v-if="required" class="required">(Required)</span>
    </div>
    <vSelect
      :components="{ Deselect }"
      :options="options"
      :value="currentOption"
      :placeholder="placeholder"
      @input="setSelected"
      @search="onSearch"
    >
      <template slot="selected-option" slot-scope="option">
        <div class="selected">
          <div v-if="option.img" class="img-wrapper">
            <img class="image" :src="option.img" />
          </div>
        </div>
        <div class="title">{{ option.label }}</div>
      </template>

      <template v-slot:option="option">
        <div class="unselected">
          <div v-if="option.img" class="img-wrapper">
            <img
              v-if="option.img"
              class="image"
              :src="option.img"
              alt="image"
            />
          </div>
          <span class="title">{{ option.label }}</span>
          <!-- <span class="subtitle">{{ option.key }}</span> -->
        </div>
      </template>
    </vSelect>
    <div v-for="(error, idx) in errors" :key="idx" class="error">
      {{ error }}
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import vSelect from "vue-select";

export default Vue.component("VVueSelect", {
  components: {
    vSelect
  },

  props: {
    options: VueTypes.arrayOf(
      VueTypes.shape({
        key: VueTypes.key,
        label: VueTypes.string,
        value: VueTypes.oneOfType([VueTypes.string, VueTypes.number]),
        img: VueTypes.string
      })
    ).required,

    value: VueTypes.any,
    label: VueTypes.string,
    placeholder: VueTypes.string,
    errors: VueTypes.arrayOf(VueTypes.string).def([]),
    withDeselect: VueTypes.bool,
    required: VueTypes.bool,
    onSearch: VueTypes.func,
    extraClass: VueTypes.string
  },

  data() {
    return {
      // Deselect: {
      //   render: createElement => createElement("span", "❌")
      // }
    };
  },

  computed: {
    currentOption() {
      return this.getCurrentOption(this.value);
    },

    isOptionSingular() {
      return this.options.length === 1;
    }
  },

  methods: {
    setSelected(selected) {
      this.value = selected.value;
      this.$emit("select", this.currentOption || {});
    },

    getCurrentOption(value) {
      return this.options.find(option => option.value === value);
    }
  }
});
</script>

<style lang="scss">
$ns: "v-select";
@import "vue-select/src/scss/vue-select.scss";
// .v-select .vs__search::placeholder,
// .v-select .vs__dropdown-toggle,
// .v-select .vs__dropdown-menu {
//   display: flex;
//   position: relative;
//   background: #dfe5fb;
//   border: none;
//   color: #394066;
//   text-transform: lowercase;
//   font-variant: small-caps;
// }
//
.#{$ns} {
  .vs__selected {
    width: 94%;
  }

  .vs__selected-options {
    @include textCropEllipsis();
    input {
      &::placeholder {
        font-family: "Lato-Light", sans-serif;
        font-style: italic;
        font-size: 15px;
        color: #979797;
      }
    }
  }

  &.singular {
    .vs__dropdown-menu {
      padding-bottom: 0;
    }
  }
}

.#{$ns}__label-wrapper {
  text-align: start;
  padding-left: 8px;
  padding-bottom: 14px;
  .required {
    font-size: 15px;
    font-family: Lato-Light, sans-serif;
  }
}

.#{$ns} {
  .title {
    @include textCropEllipsis();
  }

  .selected,
  .unselected {
    display: flex;
    align-items: center;

    img {
      border: 1px solid gray;
      border-radius: 3px;
    }
  }

  /* common extra classes */
  &.noThumbnailsBorder {
    img {
      border: none;
    }
  }

  &.letter {
    .selected img {
      width: 17px;
    }
    .unselected img {
      width: 25px;
    }
  }
  /* ====== */

  .selected {
    .img-wrapper {
      max-width: 40px;
      margin-right: 8px;
      height: 22px;
      text-align: left;
    }
    img {
      height: 22px;
    }
  }

  .unselected {
    .img-wrapper {
      width: 50px;
      margin-right: 5px;
      height: 32px;
    }
    img {
      height: 32px;
      max-width: 50px;
    }

    &.singular {
      padding-bottom: 0;
    }
  }

  .vs__search {
    padding: 0 0 0 10px;
  }
  .vs__dropdown-menu {
    overflow-y: auto;
    @include customScrollbar();
  }

  .vs__dropdown-option--highlight {
    background: $primary-color;
  }

  .vs__dropdown-option {
    padding: 5px 11px;
    font-size: 14px;
    @include textCropEllipsis();
  }

  .vs__dropdown-toggle {
    cursor: pointer;
  }

  &,
  &.has-error {
    .vs__dropdown-toggle {
      transition: border-color 0.2s linear;
      &:hover,
      &:focus-within {
        border-color: $primary-color;
      }
    }
  }

  &.has-error {
    .vs__dropdown-toggle {
      border-color: $danger-color;
    }
  }
}

.error {
  width: 100%;
  font-size: 14px;
  padding-top: 7px;
  font-family: Lato-Light, sans-serif;
  text-align: left;

  &:nth-child(1) {
    padding: 0.7em 0.1em;
  }

  &,
  &:focus {
    color: $danger-color;
  }
}
</style>
